<template>
  <div>
    <div class="card-wrapper">
      <div class="card-container" v-for="card in columns" :key="'in-card' + card.definition">
        <div class="card-container--title">
          <div class="dot" :style="{ backgroundColor: card.dotColor }"></div>
          {{ card.name }}
          <span>({{ card.items.length }})</span>
        </div>
        <hr />

        <kanban-card v-for="task in card.items" :key="'in-card' + task._id" :task="task" />
      </div>
    </div>
  </div>
</template>

<script>
import KanbanCard from "@cc/task/kanban-card";

export default {
  props: ["tasks"],
  components: { KanbanCard },
  data() {
    return {
      columns: [
        { name: this.$t("task.status.todo"), definition: "TODO", items: [], dotColor: "#FF7C48" },
        { name: this.$t("task.status.in-progress"), definition: "IN_PROGRESS", items: [], dotColor: "#2998FF" },
        { name: this.$t("task.status.approval"), definition: "APPROVAL", items: [], dotColor: "#9440FF" },
        { name: this.$t("task.status.done"), definition: "DONE", items: [], dotColor: "#2ECD06" },
        { name: this.$t("task.status.not-fit"), definition: "NOT_FIT", items: [], dotColor: "red" },
        { name: this.$t("task.status.unworked"), definition: "UNWORKED", items: [], dotColor: "gray" },
      ],

      /////////
    };
  },
  computed: {},

  watch: {
    tasks: {
      immediate: true,
      deep: true,
      handler(v = []) {
        v.forEach((i) => {
          const card = this.columns.find((k) => k.definition == i.status);
          card.items = [];
        });

        v.forEach((i) => {
          const card = this.columns.find((k) => k.definition == i.status);
          card.items.push(i);
        });
        this.$forceUpdate();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tasks";
</style>
